export default {
  toolbar: {
    unlock: "Ontgrendel factuurnummer",
    lock: "Vergrendel factuurnummer",
    saveSettingsFirst: "Instellingen die niet opgeslagen zijn, kunnen niet vergrendeld worden.",
  },

  general: {
    title: "Algemene facturatie instellingen",
    requires: {
      defaultCountry: {
        text: "Stel een standaard land in, alvorens de algemene facturatie instellingen aangepast kunnen worden.",
        button: "Naar systeem standaarden"
      },
    },
    input: {
      defaultTax: "Standaard BTW",
      defaultTerm: "Standaard factuurtermijn",
      termType: {
        day: "dagen",
        month: "maanden",
        week: "weken",
      },
    },
  },

  invoiceNumber: {
    title: "Factuurnummer instellingen",
    input: {
      startNumber: "Startnummer",
      numberZeroes: {
        label: "Factuurnummer lengte",
        explain: "Minimaal aantal cijfers waar het factuurnummer, zonder toevoeging, uit moet bestaan.",
      },
      format: {
        label: "Factuurnummer formaat",
        explain: "Gebruik speciale tekens: maand {m}, jaar {y}, volledig jaar {Y} factuurnummer {n}"
      },
      resetInvoiceNumberOn: {
        label: "Herstart factuurnummer",
        yearly: "Jaarlijks",
        monthly: "Maandelijks",
      },
    },
    text: {
      nextUp: "Eerstvolgende factuurnummer:",
    },
  },

  printTemplate: {
    title: "Facturatie print templates",
    button: {
      activate: "Kies",
      example: "Voorbeeld"
    }
  },

  button: {
    submit: "Opslaan",
  },

  api: {
    patch: {
      defaultSettings: {
        success: "Algemene facturatie instellingen opgeslagen.",
      },
      invoiceNumber: {
        success: "Factuurnummer instellingen opgeslagen."
      }
    },
  },
}
